import React from 'react'
import './profileInfoChip.css'
function ProfileInfoChip({ profilePic, name }) {
    console.log('profilePic', profilePic)
    return (
        <div className="d-flex align-items-center justify-content-center profilePicContainer1">
            <img src={profilePic}></img>
            <h6>{name}</h6>
        </div>
    )
}

export default ProfileInfoChip
